import http from 'common-module/src/util/http';

async function globalSearch({ keyword, pageNumber, pageSize }) {
  return http.post('/sys-search/total-station', { keyword, pageNumber, pageSize });
}
async function getIssueId({ id }) {
  return http.post('/issue/get/by-subtask', { issueId: id });
}

const state = {
  list: [],
  sum: [],
  pageNumber: 1,
  pageSize: 10,
  hasNextPage: false
};

const getters = {
  issues: state => {
    return state.list.filter(sub => sub.type === 'issue');
  },
  subtasks: state => {
    return state.list.filter(sub => sub.type === 'subtask');
  },
  epics: state => {
    return state.list.filter(sub => sub.type === 'epic');
  },
  sum: state => {
    const result = {};
    for (const type of state.sum) {
      result[type.type] = type.count;
    }
    return result;
  },
  hasNextPage: state => {
    return state.hasNextPage;
  }
};

const mutations = {
  SET_LIST(state, data) {
    state.list = data.details.list;
  },
  PUSH_LIST(state, data) {
    state.list = [...state.list, ...data.details.list];
  },
  RESET_LIST(state) {
    state.list = [];
  },
  SET_SUM(state, data) {
    state.sum = data.typeCounts;
  },
  RESET_SUM(state) {
    state.sum = [];
  },
  SET_PAGE_NUMBER(state, data) {
    state.pageNumber = data;
  },
  RESET_PAGE_NUMBER(state) {
    state.pageNumber = 1;
  },
  SET_HAS_NEXT_PAGE(state, data) {
    state.hasNextPage = data.details.hasNextPage;
  },
  RESET_HAS_NEXT_PAGE(state) {
    state.hasNextPage = false;
  }
};
const actions = {
  async query({ commit }, keyword) {
    const data = await globalSearch({ keyword, pageNumber: 1, pageSize: 10 });
    commit('SET_LIST', data);
    commit('SET_SUM', data);
    commit('SET_HAS_NEXT_PAGE', data);
  },
  async queryMore({ state, commit }, keyword) {
    commit('SET_PAGE_NUMBER', state.pageNumber + 1);
    const data = await globalSearch({ keyword, pageNumber: state.pageNumber, pageSize: 10 });
    commit('PUSH_LIST', data);
    commit('SET_HAS_NEXT_PAGE', data);
  },
  reset({ commit }) {
    commit('RESET_LIST');
    commit('RESET_SUM');
    commit('RESET_PAGE_NUMBER');
    commit('RESET_HAS_NEXT_PAGE');
  },
  async getSubtaskParentId(_, { id }) {
    const data = await getIssueId({ id });
    return data.id;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
